var React = require('react');

function IconClose (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("path",{"d":"M76.35,1.85 C75.35,0.85 73.75,0.85 72.85,1.85 L39.05,35.55 L4.35,0.75 C3.35,-0.25 1.75,-0.25 0.85,0.75 C-0.15,1.75 -0.15,3.35 0.85,4.25 L35.55,39.05 L0.75,73.85 C-0.25,74.85 -0.25,76.45 0.75,77.35 C1.25,77.85 1.85,78.05 2.55,78.05 C3.25,78.05 3.85,77.85 4.35,77.35 L39.15,42.55 L72.85,76.25 C73.35,76.75 73.95,76.95 74.65,76.95 C75.35,76.95 75.95,76.75 76.45,76.25 C77.45,75.25 77.45,73.65 76.45,72.75 L42.65,39.05 L76.35,5.35 C77.25,4.35 77.25,2.75 76.35,1.85 Z"})));
}

IconClose.defaultProps = {"width":"78px","height":"79px","viewBox":"0 0 78 79","version":"1.1"};

module.exports = IconClose;

IconClose.default = IconClose;
